export class PhysicalInventoryCreateItem {
    public date: Date = new Date();
    public name: string = '';
}